export function getImageNameFromURL(url?: String) {
    if (!url) return "";

    let urlSplit: string[] = [];
    urlSplit = url.split("/");
    return urlSplit[urlSplit.length - 1];
}
